import React, { type HTMLAttributes } from 'react';

import Immutable from 'immutable';

import { Taxonomy } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import type { ParagraphSelectedThemes as ParagraphSelectedThemesType } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphSelectedThemesProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphSelectedThemesType>;
}

const ParagraphSelectedThemes: React.FC<ParagraphSelectedThemesProps> = ({ entity }) => {
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;
  const data = entity.toJS();

  return (
    // @ts-ignore
    <Container id={paragraphKey} className="ParagraphSelectedThemes">
      <div className="row">
        <div className="col-12 col-md-10">
          <div className="ParagraphSelectedThemes__title">
            <span>{data.field_title[0].value}</span>
          </div>
          {data.field_body[0]?.value && (
            <WysiwygField className="ParagraphSelectedThemes__body" html={data.field_body[0].value} />
          )}
        </div>
      </div>
      <div className="row">
        {data.field_themes.map((theme) => (
          <Taxonomy
            viewMode="teaser"
            entity={Immutable.fromJS(theme).get('entity')}
          />
        ))}
      </div>
    </Container>
  );
};

export default ParagraphSelectedThemes;
